/** SPEC §24.1: start van de Teams-app — inloggen met het Teams-token en doorgaan naar de gevraagde pagina. */
import { useEffect, useState } from 'react';
import { Icoon } from '../ui/Icoon';

/** Alleen een pad binnen de app (geen //host of javascript:). */
const veiligPad = (p: string | null) => (p && /^\/(?!\/)[\w\-/?=&%.]*$/.test(p) ? p : '/');

export function TeamsStart() {
  const [fout, setFout] = useState<string | null>(null);
  const [poging, setPoging] = useState(0);
  const pagina = veiligPad(new URLSearchParams(window.location.search).get('pagina'));
  useEffect(() => {
    let weg = false;
    (async () => {
      try {
        const { app, authentication } = await import('@microsoft/teams-js');
        await Promise.race([app.initialize(), new Promise((_, nee) => setTimeout(() => nee(new Error('Deze pagina is bedoeld voor de bsmartr-app in Microsoft Teams.')), 8000))]);
        const token = await authentication.getAuthToken();
        const r = await fetch('/auth/teams', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ token }) });
        const j = (await r.json().catch(() => ({}))) as { naar?: string; fout?: string };
        if (!r.ok) throw new Error(j.fout ?? 'Inloggen via Teams is mislukt');
        try {
          sessionStorage.setItem('ep-teams', '1');
        } catch {
          /* geen opslag: niet erg */
        }
        if (!weg) window.location.replace(j.naar === '/?kies=1' ? '/?kies=1' : pagina);
      } catch (e) {
        const m = (e as Error)?.message || String(e);
        if (!weg && /parent window|not initialized|SDK/i.test(m)) return setFout('Deze pagina is bedoeld voor de bsmartr-app in Microsoft Teams.');
        if (!weg) setFout(/consent|resourceRequiresConsent|invalid_grant|AADSTS65001/i.test(m) ? 'Je beheerder moet de bsmartr-app eerst toestemming geven in Microsoft Entra. Open bsmartr in de browser en log daar in met Microsoft.' : m);
      }
    })();
    return () => {
      weg = true;
    };
  }, [poging, pagina]);
  return (
    <div className="inlog-scherm" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div className="paneel kolom" style={{ maxWidth: 420, gap: 14, textAlign: 'center', alignItems: 'center' }}>
        <img src="/icon-192.png" alt="" width={56} height={56} style={{ borderRadius: 12 }} />
        {!fout ? (
          <>
            <b>bsmartr wordt geopend…</b>
            <span className="klein mute">Je wordt ingelogd met je Microsoft-account.</span>
          </>
        ) : (
          <>
            <b>Inloggen via Teams lukte niet</b>
            <span className="klein">{fout}</span>
            <div className="rij" style={{ gap: 8, justifyContent: 'center' }}>
              <button className="knop" onClick={() => { setFout(null); setPoging(poging + 1); }}>
                <Icoon naam="refresh-cw" maat={16} /> Opnieuw
              </button>
              <a className="knop primair" href={pagina} target="_blank" rel="noopener">
                <Icoon naam="external-link" maat={16} /> Open in browser
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
